import gql from 'graphql-tag';

export const GET_MARKETS = gql`
  query GetMarkets {
    accounting {
      getMarkets {
        id
        name
      }
    }
  }
`;
